import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowsRightDownIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.9199 6.62a.9992.9992 0 0 0-.21-.33l-3-3a1.0037 1.0037 0 0 0-.71-.2942 1.0041 1.0041 0 0 0-.71 1.7141l1.3 1.29h-8.59a3 3 0 0 0-3 3v8.59l-1.29-1.3a1.0041 1.0041 0 1 0-1.42 1.42l3 3a.9992.9992 0 0 0 .33.21.9402.9402 0 0 0 .76 0 .9991.9991 0 0 0 .33-.21l3-3a1.0041 1.0041 0 0 0-1.42-1.42l-1.29 1.3v-8.59a1 1 0 0 1 1-1h8.59l-1.3 1.29a1.001 1.001 0 0 0-.2958.71 1.0008 1.0008 0 0 0 .2958.71.9989.9989 0 0 0 1.0946.2189.9966.9966 0 0 0 .3254-.2189l3-3a.9991.9991 0 0 0 .21-.33.9992.9992 0 0 0 0-.76Z"/>
  </SvgIcon>
}

export default LineArrowsRightDownIcon
